import { boolean, object, z } from "zod";

export enum TreatmentType {
  COVERAGE = "Treatment",
  CONCIERGE = "ConciergeTreatment",
}

export const TreatmentSchema = object({
  productConciergeEnabled: boolean(),
});

export type TreatmentSettings = z.infer<typeof TreatmentSchema>;
